import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Account from "./pages/Account";
import FavoritesPage from "./pages/FavoritesPage";
import B2B from "./pages/B2B";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import StaticPage from "./pages/StaticPage";
import Contact from "./pages/Contact";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminAktarAI from "./pages/admin/AdminAktarAI";
import AdminInvoices from "./pages/admin/AdminInvoices";
import AdminMarketplaces from "./pages/admin/AdminMarketplaces";
import AdminCoupons from "./pages/admin/AdminCoupons";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminPages from "./pages/admin/AdminPages";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminReports from "./pages/admin/AdminReports";
import AdminCari from "./pages/admin/AdminCari";
import AdminStock from "./pages/admin/AdminStock";
import AdminBank from "./pages/admin/AdminBank";
import AdminKasa from "./pages/admin/AdminKasa";
import AdminAds from "./pages/admin/AdminAds";
import AdminPlans from "./pages/admin/AdminPlans";
import AdminBestSellers from "./pages/admin/AdminBestSellers";
import AdminChecks from "./pages/admin/AdminChecks";
import AdminCashflow from "./pages/admin/AdminCashflow";
import AdminBarcodes from "./pages/admin/AdminBarcodes";
import QuotePage from "./pages/QuotePage";
import EkstrePage from "./pages/EkstrePage";
import MediaRedirect from "./pages/MediaRedirect";
import NfcRedirect from "./pages/NfcRedirect";
import SoruCevap from "./pages/SoruCevap";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CategoryLanding from "./pages/CategoryLanding";
import AdminAI from "./pages/admin/AdminAI";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminCards from "./pages/admin/AdminCards";
import AdminQuestions from "./pages/admin/AdminQuestions";
import AdminStockAlerts from "./pages/admin/AdminStockAlerts";
import AdminFinance from "./pages/admin/AdminFinance";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminIntegrationTr from "./pages/admin/AdminIntegrationTr";
import AdminChannelDetail from "./pages/admin/AdminChannelDetail";
import InstallPWA from "./components/InstallPWA";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — synchronous to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/urunler" element={<Products />} />
        <Route path="/urun/:slug" element={<ProductDetail />} />
        <Route path="/sepet" element={<CartPage />} />
        <Route path="/odeme" element={<Checkout />} />
        <Route path="/siparis/:orderNumber" element={<OrderSuccess />} />
        <Route path="/giris" element={<AuthPage />} />
        <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
        <Route path="/sifre-sifirla" element={<ResetPassword />} />
        <Route path="/hesap" element={<Account />} />
        <Route path="/favoriler" element={<FavoritesPage />} />
        <Route path="/b2b" element={<B2B />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/sayfa/:slug" element={<StaticPage />} />
        <Route path="/kategori/:slug" element={<CategoryLanding />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/soru-cevap" element={<SoruCevap />} />
        <Route path="/media/:name" element={<MediaRedirect />} />
        <Route path="/nfc" element={<NfcRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="/teklif/:token" element={<QuotePage />} />
      <Route path="/ekstre/:token" element={<EkstrePage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="urunler" element={<AdminProducts />} />
        <Route path="urunler/yeni" element={<AdminProductForm />} />
        <Route path="urunler/:productId" element={<AdminProductForm />} />
        <Route path="kategoriler" element={<AdminCategories />} />
        <Route path="siparisler" element={<AdminOrders />} />
        <Route path="pos" element={<Navigate to="/admin/faturalar?tab=pos" replace />} />
        <Route path="b2b" element={<AdminQuotes />} />
        <Route path="teklifler" element={<AdminQuotes />} />
        <Route path="pazaryerleri" element={<AdminMarketplaces />} />
        <Route path="pazaryerleri/:channelId" element={<AdminChannelDetail />} />
        <Route path="kuponlar" element={<AdminCoupons />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="ortam" element={<AdminMedia />} />
        <Route path="sayfalar" element={<AdminPages />} />
        <Route path="raporlar" element={<AdminReports />} />
        <Route path="cari" element={<AdminCari />} />
        <Route path="stok" element={<AdminStock />} />
        <Route path="aktar-ai" element={<AdminAktarAI />} />
        <Route path="banka" element={<AdminBank />} />
        <Route path="kasa" element={<AdminKasa />} />
        <Route path="reklamlar" element={<AdminAds />} />
        <Route path="faturalar" element={<AdminInvoices />} />
        <Route path="odeme-planlari" element={<AdminPlans />} />
        <Route path="en-cok-satanlar" element={<AdminBestSellers />} />
        <Route path="cek-senet" element={<AdminChecks />} />
        <Route path="gelir-gider" element={<AdminCashflow />} />
        <Route path="barkod-merkezi" element={<AdminBarcodes />} />
        <Route path="ayarlar" element={<AdminSettings />} />
        <Route path="asistan" element={<AdminAI />} />
        <Route path="odeme-yontemleri" element={<AdminPayments />} />
        <Route path="firma-kartlari" element={<AdminCards />} />
        <Route path="sorular" element={<AdminQuestions />} />
        <Route path="stok-bildirimleri" element={<AdminStockAlerts />} />
        <Route path="finans" element={<AdminFinance />} />
        <Route path="takvim" element={<AdminCalendar />} />
        <Route path="ata-tr-baglanti" element={<AdminIntegrationTr />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <InstallPWA />
          <Toaster position="top-right" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
